import { X } from "lucide-react";
import { Button } from "../ui/Button";
import { ConsentFormStepper } from "../forms/ConsentFormStepper";
import { mapCheckoutConsentToFormValues } from "../../lib/consent-schema";
import type { CheckoutParticipant } from "../../lib/checkout-participant";
import type { ConsentFormValues } from "../../lib/consent-schema";

interface ParticipantEditModalProps {
  participant: CheckoutParticipant;
  onStepSave: (data: Partial<ConsentFormValues>) => Promise<void>;
  onComplete: (data: ConsentFormValues) => void;
  onCancel: () => void;
}

export function ParticipantEditModal({
  participant,
  onStepSave,
  onComplete,
  onCancel,
}: ParticipantEditModalProps) {
  const mergedData = mapCheckoutConsentToFormValues(participant.consent);
  const eventNames = participant.events.map((event) => event.title);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center pt-24 pb-12 px-4 z-[100]">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[calc(100vh-9rem)] flex flex-col">
        <div className="flex justify-between items-center p-6 border-b flex-shrink-0">
          <h2 className="text-xl font-semibold">Complete Consent Forms</h2>
          <Button variant="outline" size="sm" onClick={onCancel}>
            <X className="w-4 h-4" />
          </Button>
        </div>
        <div className="flex-1 overflow-hidden flex flex-col min-h-0">
          <ConsentFormStepper
            participantName={participant.displayName}
            eventRequirements={{
              requiresConsentForm: participant.requiresConsentForm,
              requiresPhotoConsent: participant.requiresPhotoConsent,
            }}
            eventNames={eventNames}
            initialData={mergedData}
            onStepSave={onStepSave}
            onComplete={onComplete}
            onCancel={onCancel}
          />
        </div>
      </div>
    </div>
  );
}
